/**
 * Saved Filters Vuex Module
 * Manages user's saved filter configurations
 */

import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
